import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'

export const fetchPlanTypeQuery = gql`
  query SearchPlanType {
    plan_type(where: { is_active : {_eq: true}}) {
      id
      name
    }
  }
`
const planType = {
  namespaced: true,
  state: {
    planTypes: []
  },
  actions: {
    async fetchAll ({ commit }) {
      try {
        const requestQuery = {
          query: fetchPlanTypeQuery
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_PLANTYPE', result.data.plan_type)
        }
      } catch (err) {
        window.console.error(err)
      }
    }
  },
  mutations: {
    SET_PLANTYPE (state, data) {
      Vue.set(state, 'planTypes', data)
    }
  },
  getters: {
    planTypesInfo: state => state.planTypes
  }
}

export default planType



// WEBPACK FOOTER //
// ./src/store/modules/plan_type.js